'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _list = require('./list.html');

var _list2 = _interopRequireDefault(_list);

var _list3 = require('./list.controller');

var _list4 = _interopRequireDefault(_list3);

require('./list.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var floraComponent = {
  bindings: {},
  template: _list2.default,
  controller: _list4.default,
  controllerAs: "vm"
};

exports.default = floraComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.component.js